import template from './objectives_summary_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class PerformanceObjectivesSummaryHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class PerformanceObjectivesSummaryHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new PerformanceObjectivesSummaryHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'PerformanceObjectivesSummaryHelp',
	dialog_class: PerformanceObjectivesSummaryHelpPage,
	template: template,
	template_filename: 'translation/dialogs/objectives_summary_help',
	provider: 'ps'
};